import * as Dialog from "@radix-ui/react-dialog";

export function DialogOverlay() {
  return (
    <Dialog.Root defaultOpen>
      <Dialog.Portal>
        <Dialog.Overlay className="sd-overlay"></Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
